export default __webpack_public_path__ + "static/media/AOD-assets-Video.ee9774f9.mp4";